import { Link } from 'react-router-dom';
import { siteConfig, videoPlatforms } from '@/mocks/site';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 group">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                  {siteConfig.name}
                </span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed mb-4">
                {siteConfig.slogan}
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">首页</Link>
                <Link to="/category/yingshidaquan" className="text-sm text-background-300 hover:text-primary-400 transition-colors">影视大全</Link>
                <Link to="/category/remenjuji" className="text-sm text-background-300 hover:text-primary-400 transition-colors">热门剧集</Link>
                <Link to="/category/zongyiyule" className="text-sm text-background-300 hover:text-primary-400 transition-colors">综艺娱乐</Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">视频平台</h4>
              <div className="flex flex-col gap-2">
                {videoPlatforms.slice(0, 5).map((p) => (
                  <Link
                    key={p.slug}
                    to={`/category/${p.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {p.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2 text-sm text-background-300">
                <p>{siteConfig.address}</p>
                <p>邮箱: {siteConfig.email}</p>
                <p>电话: {siteConfig.phone}</p>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-background-400">
                &copy; {currentYear} {siteConfig.name} 版权所有 | 粤ICP备XXXXXXXX号
              </p>
              <div className="flex items-center gap-4 text-xs text-background-400">
                <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
                <a href="#" className="hover:text-primary-400 transition-colors">服务条款</a>
                <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}